/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

/* Library imports */
import React, {Component} from "react";
import PropTypes from "prop-types";

/* Component imports */
import ContentLg from "../../../../ContentLg";
import ConstantsLg from "../../../../ConstantsLg";
import * as UtilityLg from "../../../../UtilityLg";
import TextboxLg from "../../../core/TextboxLg/TextboxLg";

/* Style imports */
import "./styles.css";
import Gutter from "../../../core/Gutter/Gutter";
import LoginFooter from "../../../core/LoginFooter/LoginFooter";
/*** End Imports ***/

class ResetPasswordScreen extends Component {
    constructor(props){
        super(props);

        this.state = {
            password: ''
        };

        UtilityLg.bindThisToAll(this, "onTxtBxEmailChange", "validate");
    }

    onTxtBxEmailChange (value, respObj) {
        this.setState({
            email: value
        });
        this.props.onTxtBxPswdChange(value, respObj);
    }

    /* @public method */
    validate () {
        this.TxtBxPswdRef.validateManually();
    }

    onTxtBxEmailEditClick = () => {
        this.props.onEmailEditClick();
    };

    render () {
        const {
                email
            } = this.props
        ;

        return (

            <div className="freelancer-reset-password-screen">

                <Gutter height={15}/>

                <div className="freelancer-rp-sub-hdr">{ContentLg.RESET_PSWD_SUB_HDR}</div>

                <Gutter height={20}/>

                <div className="freelancer-rp-content">
                    <TextboxLg
                        ref={e=>this.TxtBxEmailRef=e}
                        value={email}
                        maxLength={20}
                        onChange={this.onTxtBxEmailChange}
                        isRequired={true}
                        isDisabled={true}
                    />
                    <i
                        className = "material-icons btn-edit"
                        onClick = {this.onTxtBxEmailEditClick}
                    >
                        edit
                    </i>
                </div>

                <Gutter height={20}/>

                <Gutter height={40}/>

                <Gutter height={39}/>

                <div className="rrps-login-btn" onClick={this.props.onClickSendLink}>
                    <div className="rrps-login-btn-content">{ContentLg.BTN.SEND_EMAIL}</div>
                </div>

                {/* <LoginFooter
                    bottomLayerContent = {ContentLg.BOTTOM_LAYER_FOR_RECRUITER}
                    bottomLayerActionContent = {ContentLg.BOTTOM_LAYER_ACTION_FOR_RECRUITER}
                    gutterHeight = {31}
                    onClickChangeUserLoginModal = {this.props.onClickChangeUserLoginModal}
                /> */}
            </div>
        );
    }
}

ResetPasswordScreen.PropTypes = {
    email: PropTypes.string.isRequired
};

export default ResetPasswordScreen;


// WEBPACK FOOTER //
// ./src/components/RecruiterLogin/components/ResetPasswordScreen/ResetPasswordScreen.js


// WEBPACK FOOTER //
// ./src/components/freelancerLogin/components/ResetPasswordScreen/ResetPasswordScreen.js